import { Alert, theme as antTheme, Flex, Typography } from "antd"
import cls from "classname"
import { useTranslation } from "react-i18next"

import Button, { ButtonComponent } from "../../../../Components/Button"
import Private from "../../../../Components/Private"
import withPermission from "../../../../hoc/withPermission"
import { useExternalDemoMode } from "../../../../hooks/useExternalDemoMode"
import { useIncognito } from "../../../../hooks/useIncognito"
import Icon from "../../../../Icon"
import Images from "../../../../Images"
import { highAccessRoles } from "../../../../Utils/permission"
import { getButtonConfig } from "../../utils/getButtonConfig"

import "./styles.less"

const PermissionButton = withPermission(Button, highAccessRoles)

const { Title, Text } = Typography
const IntegrationCard = ({
  data,
  onClick,
  onlyConnect,
  style,
  className,
  theme,
  baRole,
  disabled,
  uploadFiles,
  onUpload,
  uploading,
  tooltip
}) => {
  const { t } = useTranslation()
  const { token } = antTheme.useToken()
  const btnConfig = getButtonConfig(data, onlyConnect)

  const externalDemoMode = useExternalDemoMode()
  const incognito = useIncognito()

  const btnIconType = data.isRequestIntegration
    ? "plus"
    : data.isDisabled
      ? onlyConnect
        ? "plugin_connected"
        : "calendar_clock"
      : data.is_connected
        ? "circle_x"
        : "plugin_connect"
  const btnText =
    data.service_name === "manual_refunds"
      ? data.is_connected
        ? "Selected"
        : "Select"
      : data.isRequestIntegration
        ? "Request integration"
        : data.isDisabled
          ? data.disabledStatus
          : data.is_connected
            ? "Disconnect"
            : "Connect"
  const showMaverickTooltip = data?.is_connected && data?.service_name === "maverick"

  const btnDisabled = data?.simpleDisabled || data?.isDisabled || disabled || externalDemoMode

  return (
    <Flex
      vertical
      gap={16}
      className={cls("integration-card", { "with-bg": data.isRequestIntegration }, className)}
      style={{ ...style }}
    >
      <Flex align="center" justify={"space-between"}>
        {Images[`integration_${data.service_name}`] ? (
          <img
            src={
              Images[
                `integration_${data.service_name}${
                  data.service_name === "premium_support" && theme === "dark" ? "_dark" : ""
                }`
              ]
            }
            className="integration-card-logo"
            alt={data.service_name}
            height={32}
            width={32}
          />
        ) : (
          <span />
        )}
        {data.is_connected && !data.has_invalid_token && (
          <Flex gap={4} align="center" className="mark-connected">
            <Icon type={"check_mark"} style={{ fontSize: 20 }} />
            <Text style={{ color: "currentColor" }}>{t("Connected")}</Text>
          </Flex>
        )}
        {data.has_invalid_token && (
          <Alert
            type="error"
            message={<Text style={{ color: "#9E1414", fontWeight: 400 }}>{"Invalid token"}</Text>}
            showIcon
            icon={<Icon type="alert_triangle_error" />}
            className="invalid-token-alert"
          />
        )}
        <Flex align={"center"} gap={8}>
          {data.is_new && !data.is_connected && (
            <Flex gap={4} align="center" className="mark-new ">
              <Text style={{ color: "currentColor", textTransform: "uppercase" }}>{t("New")}</Text>
            </Flex>
          )}
          {data.is_beta && !data.is_connected && (
            <Flex gap={4} align="center" className="mark-beta ">
              <Text style={{ color: "currentColor" }}>{t("BETA")}</Text>
            </Flex>
          )}
        </Flex>
      </Flex>
      <div>
        <Flex gap={8} align="center" style={{ marginBottom: 8 }} wrap="nowrap">
          <Title level={5} style={{ lineHeight: "22px", margin: 0, whiteSpace: "nowrap" }}>
            {t(data.title?.includes("Manual") ? "Other" : data.title)}
          </Title>
          {data?.connected_account ? (
            <Text
              type="secondary"
              // The tooltip is a second leak of the same value on hover - suppress it too while masked.
              ellipsis={{ tooltip: incognito ? undefined : data.connected_account }}
              style={{
                maxWidth: "100%",
                border: "1px solid",
                borderColor: token?.colorBorder,
                padding: "0 7px",
                borderRadius: token?.radiusBase
              }}
            >
              <Private>{data.connected_account}</Private>
            </Text>
          ) : null}
        </Flex>
        <Text type="secondary">{t(data.description)}</Text>
      </div>
      <Flex
        gap={12}
        vertical
        style={{
          marginTop: "auto",
          width: "100%",
          flexDirection: showMaverickTooltip && "row"
        }}
      >
        {/* {uploadFiles && (
          <Button
            size="large"
            icon={<Icon type={"arrow_out_of_box"} style={{fontSize: 20}}/>}
            onClick={() => onUpload(data)}
            loading={uploading}
          >
            Upload data
          </Button>
        )} */}
        <PermissionButton
          type={btnConfig.type}
          size="large"
          danger={data.is_connected && !onlyConnect && !data?.has_invalid_token && !btnDisabled}
          disabled={btnDisabled}
          icon={btnConfig.icon ? <Icon type={btnConfig.icon} style={{ fontSize: 20 }} /> : null}
          onClick={() => onClick(data)}
          className="flex center"
          style={{ marginTop: "auto", width: showMaverickTooltip && "100%" }}
          role={data?.withoutPermission ? null : baRole}
        >
          {t(btnConfig.text)}
        </PermissionButton>
        {showMaverickTooltip && (
          <Tooltip title={tooltip(data)} rootClassName="maverick-tooltip">
            <ButtonComponent
              size="large"
              icon={<Icon type={"circle_info_simple"} />}
              style={{ width: "auto" }}
              onClick={null}
              className="flex center"
            />
          </Tooltip>
        )}
      </Flex>
    </Flex>
  )
}

export default IntegrationCard
